exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course-container {\n  background-color: #047ba3;\n  background-image: linear-gradient(#00aeef 0%, #047ba3 85%);\n  position: relative;\n  min-height: calc(100% - 220px);\n  padding: 0 0 70px; }\n  .course-container h2 {\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 6px; }\n\n.copy-block {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 10px;\n  margin-bottom: 40px; }\n  .copy-block p {\n    margin: 0;\n    font-weight: bold;\n    font-size: 15px;\n    margin: 0; }\n    .copy-block p:first-child {\n      margin-bottom: 10px; }\n\n.course-detail-showing .course-list {\n  display: block;\n  max-height: 0px;\n  overflow: hidden; }\n\n.course-levels {\n  margin: 0; }\n  .course-levels li {\n    list-style: none;\n    margin: 0 0 2px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/dev/um.stamps/src/app/courses/courses.component.scss
// module id = ../../../../../src/app/courses/courses.component.scss
// module chunks = main